import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  ConversationThread,
  ContextData,
  ExecutionPlanAction,
  ConversationThreadExecutionPlanActionState,
  Message,
  ActionTarget,
} from '@flowx/designer/modules/ai/common/api/conversation-api.types'

import { SerializedSelectedActions } from './ai-conversation.dictionary'

export const ExecutionPlanActions = createActionGroup({
  source: 'ExecutionPlan',
  events: {
    pendingExecutionPlanChangesAfterKeepSavedToNewMessage: props<{
      threadMessage: Message
      threadId: string
    }>(),
    patchExecutionPlanActionApiResponse: props<{
      thread: ConversationThread
      conversationId: string
    }>(),
    deleteExecutionPlan: emptyProps(),
    keepExecutionPlanUpdates: props<{ plan: SerializedSelectedActions }>(),
    discardExecutionPlanUpdate: emptyProps(),
    runExecutionPlanConfirmation: props<{
      actionId: string
      target: ActionTarget
      context?: ContextData
    }>(),
    patchExecutionPlanAction: props<{
      actionId: string
      actionUpdate: Partial<ExecutionPlanAction>
    }>(),
    patchExecutionPlanActionState: props<{
      actionId: string
      actionState: ConversationThreadExecutionPlanActionState
      messageId: string
    }>(),
    patchExecutionPlanActionTargetSuccess: props<{
      actionId: string
      target: ActionTarget
    }>(),
    replaceThreadMessageExecutionPlanSuccess: props<{ conversationId: string; threadId: string }>(),
  },
})
